import { InlineMessage } from '@strata/react-inline-message';

export const NewTemplateNote = () => (
    <InlineMessage
        intent={InlineMessage.Intent.INFO}
        wrapText
        label="New templates or edits to existing templates will not affect current live referrals. Once a template is saved, it will apply to future live referrals."
    />
);
